"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var qrcode_1 = __importDefault(require("qrcode"));
function copyTextToClipboard(text) {
    try {
        var a = document.createElement('input');
        document.body.appendChild(a);
        a.value = text;
        a.select();
        document.execCommand("copy");
        document.body.removeChild(a);
        return true;
    }
    catch (err) {
        console.log("Problem copying to clipboard", err);
        return false;
    }
}
exports.copyTextToClipboard = copyTextToClipboard;
function getDirectURL(shortcode) {
    if (shortcode) {
        console.log("Root URL: ", window.zlurlparams.rooturl);
        console.log("Referrer: ", document.referrer);
        var root = undefined;
        if (window.zlurlparams.rooturl) {
            root = window.zlurlparams.rooturl;
        }
        if (!root) {
            root = document.referrer;
            try {
                console.log("Origin: ", window.parent.location.origin);
                console.log("Path: ", window.parent.location.pathname);
                root = window.parent.location.origin + window.parent.location.pathname;
            }
            catch (_a) {
                console.log("Error accessing parent url");
            }
        }
        window.zlurlparams.shortcode = shortcode;
        var url = root;
        if (url.includes("?")) {
            if (url.includes("shortcode=")) {
                url.replace(/shortcode=[\w\d]*/, "shortcode=" + shortcode);
            }
            else {
                url += "&shortcode=" + shortcode;
            }
        }
        else {
            url += "?shortcode=" + shortcode;
        }
        return url;
    }
    return undefined;
}
exports.getDirectURL = getDirectURL;
function getQRCodeImage(shortcode) {
    var settings = { margin: 0 };
    var url = getDirectURL(shortcode);
    return qrcode_1.default.toDataURL(url, settings);
}
exports.getQRCodeImage = getQRCodeImage;
function formatMessage(intl, message, values) {
    // if (values){
    //     const entries = Object.entries(values);
    //     for (let e=0;e<entries.length;e++){
    //         if (typeof entries[e][1] === 'string'){
    //             values[entries[e][0]] = entries[e][1].replace(/&(?!(lt|gt|amp);)/gm, "&amp;");
    //         }
    //     }
    // }
    var realMessage = __assign({}, message);
    var fakeDefault = "garbage";
    if (process.env.REACT_APP_BRP_BRAND) {
        message.id = message.id + "_" + process.env.REACT_APP_BRP_BRAND;
        message.defaultMessage = fakeDefault;
    }
    var test = intl.formatMessage(message, values);
    if (test === fakeDefault) {
        return intl.formatMessage(realMessage, values);
    }
    else {
        return test;
    }
}
exports.formatMessage = formatMessage;
function svMatchOrNewer(queryVersion, target) {
    var query = queryVersion.split(".");
    var min = target.split(".");
    if (query.length === min.length) {
        for (var v = 0; v < min.length; v++) {
            if (Number(query[v]) < Number(target[v])) {
                return false;
            }
            else if (Number(query[v]) > Number(min[v])) {
                return true;
            }
        }
        return true;
    }
    return false;
}
exports.svMatchOrNewer = svMatchOrNewer;
//# sourceMappingURL=utils.js.map